import React from 'react'
import './loadingComponent.css'
import logoSuperior from '../../../assets/img/loading-logo.png'

export const LoadingComponent = () => {
    return (
        <div className='logo-loading-container'>
            {/* <span className='glow-text'>Cargando usuarios...</span> */}

            <img className='logo-loading' src={logoSuperior} alt="Cargando..." />

        </div>
    )
}
